import { Component, Input } from '@angular/core';
import { IAnnualReport, IPrintOptions } from '@modeso/types__aumico-lib-annualreport-be';
import { UntilDestroy } from '@ngneat/until-destroy';
import { IOptions, ISectionData, SectionIds } from '../../../../../../../aumico-lib-annualreport-fe/src/lib';
import { SectionFactoryService } from '../../services/pdf-tron-SectionFactoryService.service';
import { FcpModel } from '../domain/models/fcp.model';

@UntilDestroy()
@Component({
    selector: 'aumico-fcp-print-preview',
    templateUrl: 'fcpPrintPreview.component.html',
})
export class FinancialClosingProcessPrintPreviewComponent {
    sectionData: ISectionData;
    private _domainModel: FcpModel;

    @Input()
    get domainModel(): FcpModel {
        return this._domainModel;
    }
    set domainModel(model: FcpModel) {
        this._domainModel = model;
        this.sectionData = this.getSectionData();
    }

    @Input()
    translationLocale: string;
    @Input()
    onlyDefaultDisplay: boolean = false;

    constructor(private readonly sectionFactoryService: SectionFactoryService) {}

    getSectionData(): ISectionData {
        const factory = this.sectionFactoryService.getFactory(SectionIds.FINANCIAL_CLOSING_PROCESS);

        if (this.onlyDefaultDisplay) {
            const section = factory.createSectionWithDefaultOptions(this.domainModel);
            return section;
        } else {
            const annualReport: IAnnualReport = {} as IAnnualReport;
            const printOptions: IPrintOptions = {} as IPrintOptions;
            const section = factory.createSection(
                annualReport,
                printOptions,
                annualReport,
                [],
                {} as IOptions,
                new Map<string, string>(),
                'de-ch',
                this.translationLocale,
                'de-ch',
            );
            return section;
        }
    }
}
